import DropdownItem from './DropdownItem'

const Dropdown = (props) => {
  if (!props.visible) {
    return
  }

  return <div class='topic-selector-dropdown'>
    { props.items.map(item => <DropdownItem title={item.title} href={item.url} />) }
  </div>
}

export default Dropdown
